/**
 * UI-6b Task 11 — ChannelMix config editor.
 *
 * Phase 1: no settings — see Renderer.tsx for the Phase 1 placeholder
 * rationale. The editor still mounts so the WidgetConfigDialog has
 * something to render when an admin opens this widget's settings; it
 * just states there's nothing to configure yet.
 */
import type { JSX } from 'react'
import type { ChannelMixConfig } from './Renderer.js'

interface Props {
  config: ChannelMixConfig
  onChange: (next: ChannelMixConfig) => void
}

export function ChannelMixConfigEditor(_props: Props): JSX.Element {
  return (
    <div data-testid="channel-mix-config-editor" className="text-sm text-gray-500">
      <p>No settings.</p>
    </div>
  )
}
